import React from 'react';

const QuoteLoading = () => (
  <div className="quote-loading text-center">
    <img src={Spree.image_assets.ajax_loader_blue_64} alt="loading" />
    <span>We are looking for best prices for your pcbs. Please wait...</span>
  </div>
);

export default QuoteLoading;
